import DOMPurify from 'dompurify'

import { useSelector } from '@tabeeb/store'
import { getCurrentFormRecordSignature } from '@tabeeb/modules/forms/selectors'
import { Group, Stack, Subheader3 } from '@collaborate-health/uikit'

import { SignatureValue } from './SignatureViewer.styles'

const SignatureViewer: React.FC = () => {
  const signature = useSelector(getCurrentFormRecordSignature)
  if (!signature) {
    return null
  }

  return (
    <Stack pt={0.5} pb={1} paddingInline={1.5}>
      <Group>
        <Subheader3>Signature</Subheader3>
        <SignatureValue dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(signature) }} />
      </Group>
    </Stack>
  )
}

export default SignatureViewer

